import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';
import { contactsKeys } from './contacts/keys';

const studentRosterKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'student_roster'] as const, // every student/student_roster query for a specific cause that we have
    id: <U extends QueryKeyParam>(
      uuid: U // uuid here is the student id
    ) =>
      createQueryKey({
        all: [...keys, 'student_roster', uuid] as const, // all related student_roster for a specific studentId
        detail: [...keys, 'student_roster', uuid, 'detail'] as const,
        groups: [...keys, 'student_roster', uuid, 'groups'] as const,
        contacts: contactsKeys([...keys, 'student_roster', uuid, 'contacts']),
      }),
  });

export { studentRosterKeys };
